<template>
  <div class="container">
    <p>
      Diseña y automatiza flujos de comunicación para interactuar con tus contactos de manera
      oportuna.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>

    <a-form class="form" layout="vertical" :model="formState">
      <a-form-item name="name">
        <a-input class="search" v-model:value="formState.name" placeholder="Buscar por nombre">
          <template #prefix>
            <SearchOutlined />
          </template>
        </a-input>
      </a-form-item>

      <a-form-item class="state">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          class="select"
          v-model:value="formState.type"
        >
          <a-select-option :value="''">Todos los tipos</a-select-option>
          <a-select-option :value="SequenceType.Multichannel">Multicanal</a-select-option>
          <a-select-option :value="SequenceType.AutomaticProgressive">Progresivo automático</a-select-option>
        </a-select>
      </a-form-item>

      <CampaignPicker
        v-model:value="formState.portfolio"
        withName
        withOutEntity
        defaultBehavior
        showAll
      />

      <ChannelsPicker
        v-model:value="formState.channel"
        class="form__item"
        defaultBehavior
        toSequence
      />

      <!-- <a-form-item class="type">
        <a-select :getPopupContainer="triggerNode => triggerNode.parentNode" class="select" v-model:value="formState.type">
          <a-select-option :value="''">Todos los canales</a-select-option>
          <a-select-option :value="TemplateType.Html">Plantilla HTML</a-select-option>
          <a-select-option :value="TemplateType.Default">Creado desde Score</a-select-option>
        </a-select>
      </a-form-item> -->

      <a-form-item class="state">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          class="select"
          v-model:value="formState.status"
        >
          <a-select-option :value="''">Todos los estados</a-select-option>
          <a-select-option :value="SequenceStatus.Active">Activo</a-select-option>
          <a-select-option :value="SequenceStatus.Inactive">Inactivo</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>

    <CustomScrollbar height="calc(100vh - 205px)">
      <SequencesList :sequences="sequences" @update="fetchSequencesList" />
    </CustomScrollbar>
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { SearchOutlined } from "@ant-design/icons-vue";
import { debounce } from "lodash";

import { Sequence, SequenceStatus } from "@/@types/flows/sequences";
import { ListFilterDto } from "@/@types/flows/sequences/dto";
import { SequenceType } from "@/app/flows/sequences/utils/enums";

import SequencesList from "@/app/flows/sequences/components/lists/SequencesList.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { sequenceService } from "@/app/flows/sequences/services/Sequence.service";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import ChannelsPicker from "@/app/shared/components/pickers/ChannelsPicker.vue";

import { useSocket } from "@/app/shared/composables/useSocket";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/flujos/modulo-secuencias/`;

const formState: ListFilterDto = reactive({
  name: "",
  portfolio: "",
  channel: "",
  type: "",
  status: "",
});

const sequences = ref<Sequence[]>([]);

const fetchSequencesList = async () => {
  sequences.value = await sequenceService.getList(formState);
};

watch(
  formState,
  debounce(() => {
    fetchSequencesList();
  }, 400)
);

onMounted(() => fetchSequencesList());

const store = useStore();
const { vueSocket } = useSocket();

vueSocket.subscribe("refreshSequences", (data) => {
  if (!store.getters.isSocketEventForCurrentUser(data)) return;
  console.log(data, 'refreshSequences');
  fetchSequencesList();
});
</script>

<style scoped lang="sass">
.container
  padding: 12px 22px

p
  margin-bottom: 20px
  color: $gray-8

.form
  display: flex
  gap: 8px
  margin-bottom: 20px

  .ant-form-item
    margin: 0

  .search
    min-width: 250px

  .select
    min-width: 180px

  &__item
    min-width: 180px
</style>
